// project import
import dashboard from './dashboard';
import templates from './templates';
import agendaServicios from './agenda-servicios';
import agendaDiariaTecnico from './agenda-diaria-tecnico';
import almacen from './almacen';
import cajaChica from './caja-chica';
import catalogos from './catalogos';
import comisiones from './comisiones';
import cotizaciones from './cotizaciones';
import finanzas from './finanzas';
import insumos from './insumos';
import ordenesServicio from './ordenes-servicio';
import tasksBoard from './tasks-board';
import kanbanBoard from './kanban-board';
import kanbanBoard2 from './kanban-board-2';
// import usuarios from './usuarios';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    almacen,
    cotizaciones,
    agendaDiariaTecnico,
    ordenesServicio,
    agendaServicios,    
    finanzas,
    catalogos,
    insumos,
    cajaChica,
    comisiones,
    templates,
    tasksBoard,
    kanbanBoard,
    kanbanBoard2,
  // usuarios,
  ]
};

export default menuItems;

